import React from 'react';
import {Box, Img} from '@chakra-ui/react';
import HeroSvg from '../../../assets/images/contact-hero.svg';
import Container from "../../../components/Container";

const ContactHero = () => {
    return (
        <>
            <Box
                pt={{base: '42px', md: '75px'}}
                pb={{base: '78px', md: '160px'}}
                borderX={'1px'}
                borderColor={'brandAlpha.200'}
            >
                <Container>
                    <Box
                        position={'relative'}
                        display={'flex'}
                        justifyContent={{base: 'start', md: 'center'}}
                    >
                        <Img src={HeroSvg} alt="companies-hero"/>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default ContactHero;
